import React, { useEffect } from "react";
import Chart from "chart.js/auto";
import HeaderLogo  from "../structure/headerlogo";
import CommonIcon from '../common/customicon';

const BrandIPPortfolio = () => {
  useEffect(() => {
    const ctx = document.getElementById("brandChart");
    if (ctx) {
      new Chart(ctx, {
        type: "bar",
        data: {
          labels: ["Q1 2025", "Q2 2025", "Q3 2025", "Q4 2025", "Q1 2026"],
          datasets: [
            { label: "Aurora Animation", data: [4.8, 5.2, 5.5, 5.9, 6.2], backgroundColor: "#3B82F6" },
            { label: "Midnight Echo", data: [2.1, 2.4, 2.6, 2.8, 3.1], backgroundColor: "#8B5CF6" },
            { label: "StarBlaze Heroes", data: [1.5, 1.8, 2.0, 2.2, 2.4], backgroundColor: "#F97316" },
          ],
        },
        options: {
          responsive: true,
          scales: {
            x: { stacked: true },
            y: { stacked: true, title: { display: true, text: "Revenue ($M)" } },
          },
        },
      });
    }
  }, []);

  return (<div className="main-content" style={{ paddingTop: 64 }}>
       <HeaderLogo />
      <div className="page-content">
        <div className="container-fluid">
          <div id="table_height">
    <div className="">
      <div className="flex items-center justify-between mb-6">
        
<div className="d-flex align-items-center mb-2">
              <div className="bg-primary text-white rounded p-2 me-3">
                <CommonIcon iconName="Briefcase" size={"24px"}  color="#fff" />
              </div>
              <div className="flex-grow-1">
                  <h1 className="h3 mb-0 fw-bold">Brand / IP Portfolio</h1>
                <p className="text-muted mb-0 small">Group contracts by brand/IP, see all licensees at a glance</p>
              </div>
</div>  

        {/* <div>
          <h1 className="text-3xl font-bold text-gray-900">Brand / IP Portfolio</h1>
          <p className="text-gray-500 mt-1">Group contracts by brand/IP, see all licensees at a glance</p>
        </div> */}
        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg">+ Add New Brand</button>
      </div>

      {/* Brand Cards */}
      <div className="grid grid-cols-3 gap-6 mb-6">
        {/* Aurora Animation */}
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <div className="bg-gradient-to-r from-blue-500 to-blue-700 p-5 text-white">
            <h2 className="text-xl font-bold">Aurora Animation</h2>
            <p className="text-blue-100 text-sm">Entertainment / Animation</p>
          </div>
          <div className="p-5">
            <div className="grid grid-cols-2 gap-3 mb-4 text-center">
              <div className="bg-blue-50 rounded-lg p-2"><p className="text-xl font-bold text-blue-700">6</p><p className="text-xs text-gray-500">Licensees</p></div>
              <div className="bg-green-50 rounded-lg p-2"><p className="text-xl font-bold text-green-700">$6.2M</p><p className="text-xs text-gray-500">Total Revenue</p></div>
              <div className="bg-purple-50 rounded-lg p-2"><p className="text-xl font-bold text-purple-700">4</p><p className="text-xs text-gray-500">Territories</p></div>
              <div className="bg-orange-50 rounded-lg p-2"><p className="text-xl font-bold text-orange-700">5</p><p className="text-xs text-gray-500">Categories</p></div>
            </div>
            <h5 className="text-sm font-semibold text-gray-500 mb-2">Active Licensees</h5>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between items-center"><span>Summit Ridge Merch</span><span className="text-green-600 font-semibold">$2.85M</span></div>
              <div className="flex justify-between items-center"><span>Golden State Apparel</span><span className="text-green-600 font-semibold">$3.40M</span></div>
              <div className="flex justify-between items-center"><span>Bright Star Retail</span><span className="text-yellow-600 font-semibold text-xs">Expiring</span></div>
              <div className="flex justify-between items-center text-gray-400"><span>+3 more</span><span></span></div>
            </div>
            <button className="w-full mt-3 border rounded-lg py-2 text-sm text-blue-600 hover:bg-blue-50">View All Details</button>
          </div>
        </div>

        {/* Midnight Echo */}
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <div className="bg-gradient-to-r from-purple-500 to-purple-700 p-5 text-white">
            <h2 className="text-xl font-bold">Midnight Echo</h2>
            <p className="text-purple-100 text-sm">Music / Entertainment</p>
          </div>
          <div className="p-5">
            <div className="grid grid-cols-2 gap-3 mb-4 text-center">
              <div className="bg-blue-50 rounded-lg p-2"><p className="text-xl font-bold text-blue-700">4</p><p className="text-xs text-gray-500">Licensees</p></div>
              <div className="bg-green-50 rounded-lg p-2"><p className="text-xl font-bold text-green-700">$3.1M</p><p className="text-xs text-gray-500">Total Revenue</p></div>
              <div className="bg-purple-50 rounded-lg p-2"><p className="text-xl font-bold text-purple-700">3</p><p className="text-xs text-gray-500">Territories</p></div>
              <div className="bg-orange-50 rounded-lg p-2"><p className="text-xl font-bold text-orange-700">3</p><p className="text-xs text-gray-500">Categories</p></div>
            </div>
            <h5 className="text-sm font-semibold text-gray-500 mb-2">Active Licensees</h5>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between items-center"><span>Horizon Peak Retail</span><span className="text-green-600 font-semibold">$1.20M</span></div>
              <div className="flex justify-between items-center"><span>NovaTech Games</span><span className="text-red-600 font-semibold text-xs">Below Min</span></div>
              <div className="flex justify-between items-center"><span>SoundWave Merch</span><span className="text-green-600 font-semibold">$1.05M</span></div>
              <div className="flex justify-between items-center text-gray-400"><span>+1 more</span><span></span></div>
            </div>
            <button className="w-full mt-3 border rounded-lg py-2 text-sm text-purple-600 hover:bg-purple-50">View All Details</button>
          </div>
        </div>

        {/* StarBlaze Heroes */}
        <div className="bg-white rounded-xl shadow overflow-hidden">
          <div className="bg-gradient-to-r from-orange-500 to-orange-700 p-5 text-white">
            <h2 className="text-xl font-bold">StarBlaze Heroes</h2>
            <p className="text-orange-100 text-sm">Action / Toys & Games</p>
          </div>
          <div className="p-5">
            <div className="grid grid-cols-2 gap-3 mb-4 text-center">
              <div className="bg-blue-50 rounded-lg p-2"><p className="text-xl font-bold text-blue-700">3</p><p className="text-xs text-gray-500">Licensees</p></div>
              <div className="bg-green-50 rounded-lg p-2"><p className="text-xl font-bold text-green-700">$2.4M</p><p className="text-xs text-gray-500">Total Revenue</p></div>
              <div className="bg-purple-50 rounded-lg p-2"><p className="text-xl font-bold text-purple-700">2</p><p className="text-xs text-gray-500">Territories</p></div>
              <div className="bg-orange-50 rounded-lg p-2"><p className="text-xl font-bold text-orange-700">2</p><p className="text-xs text-gray-500">Categories</p></div>
            </div>
            <h5 className="text-sm font-semibold text-gray-500 mb-2">Active Licensees</h5>
            <div className="space-y-2 text-sm">
              <div className="flex justify-between items-center"><span>Pacific Coast Toys</span><span className="text-red-600 font-semibold text-xs">Below Min</span></div>
              <div className="flex justify-between items-center"><span>Dreamlight Studios</span><span className="text-green-600 font-semibold">$2.10M</span></div>
              <div className="flex justify-between items-center"><span>Action Planet Inc</span><span className="text-green-600 font-semibold">$0.30M</span></div>
            </div>
            <button className="w-full mt-3 border rounded-lg py-2 text-sm text-orange-600 hover:bg-orange-50">View All Details</button>
          </div>
        </div>
      </div>

      {/* Revenue by Brand Chart */}
      <div className="bg-white rounded-xl shadow p-6">
        <h5 className="text-lg font-semibold mb-4">Revenue by Brand — Quarterly Trend</h5>
        <canvas id="brandChart" height="100"></canvas>
      </div>
    </div></div></div></div></div>
  );
};

export default BrandIPPortfolio;
